// extracted by mini-css-extract-plugin
export default {"buttons":"camera_buttons__5gRhW","btn":"camera_btn__8KJbM","centerBtn":"camera_centerBtn__IpIze","rotate":"camera_rotate__yjD5t","btnWrapper":"camera_btnWrapper__RMTlY"};